import { api } from '../core/api';
import { Dashboard, DashboardOfAsset, DashboardTypes } from '../../types/app/dashboard.types';
import { DashboardOpcSetting } from '../../types/app/dashboardOpcSetting';

export const getDashboardList = (id?: number) =>
  id
    ? api.get<DashboardOfAsset[]>(`Dashboard/GetList?parentId=${id}`).then((res) => res.data)
    : api.get<DashboardOfAsset[]>('Dashboard/GetList').then((res) => res.data);

export const getDashboard = (id: number) =>
  api.get<Dashboard>(`Dashboard/GetItem?id=${id}`).then((res) => res.data);

export const getCount = (type?: DashboardTypes, parentId?: number) =>
  api
    .get<number>(
      type === undefined
        ? `Dashboard/GetCount`
        : `Dashboard/GetCount` +
            (type ? `?type=${type}` : '') +
            (parentId ? `&parentId=${parentId}` : ''),
    )
    .then((res) => res.data);

// Opc
export const getDashboardOpcSetting = (dashboardId: number) =>
  api
    .get<DashboardOpcSetting>(`Dashboard/GetDashboardOpcSetting/?dashboardId=${dashboardId}`)
    .then((res) => res.data);
